import { Routes } from '@angular/router';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'ladder'
	},
	{
		path: 'ladder',
		loadComponent: () => import('./features/ladder/ladder.page').then(module => module.LadderPage)
	},
	{
		path: 'all-cards',
		loadComponent: () => import('./features/all-cards/all-cards.page').then(module => module.AllCardsPage)
	},
	{
		path: 'cards/new',
		loadComponent: () => import('./features/card-detail/card-detail.page').then(module => module.CardDetailPage)
	},
	{
		path: 'cards/:id',
		loadComponent: () => import('./features/card-detail/card-detail.page').then(module => module.CardDetailPage)
	},
	{
		path: 'categories',
		loadComponent: () => import('./features/categories/categories.page').then(module => module.CategoriesPage)
	},
	{
		path: 'import-export',
		loadComponent: () => import('./features/import-export/import-export.page').then(module => module.ImportExportPage)
	},
	{
		path: '**',
		redirectTo: 'ladder'
	}
];
